import { Grid } from '@mui/material';
import { HSpacer, RoutalDialog, RoutalPalette, VSpacer } from '@nx-smartmonkey/ui';
import { useState } from 'react';

import { Webhook } from '../../../../../domain/webhook/Webhook';
import { intl } from '../../../../../helpers/IntGlobalProvider';
import { useDeleteWebhook } from '../../../../../hooks/webhooks/useDeleteWebhook';
import Button from '../../../../../react-components/Button';
import InputText from '../../../../../react-components/InputText';
import Text from '../../../../../react-components/Text';

interface DeleteWebhookDialogProps {
  webhook: Webhook;
  onClose: () => void;
}

export const DeleteWebhookDialog = ({ webhook, onClose }: DeleteWebhookDialogProps) => {
  const { run: deleteWebhook } = useDeleteWebhook();
  const [confirmDeleteWebhook, setConfirmDeleteWebhook] = useState(``);

  return (
    <RoutalDialog
      open
      onCloseDialog={onClose}
      titleContent={<Text variant="h6" intlId="settings.developers.webhooks.delete.title" />}
      footerContent={
        <Grid container justifyContent="flex-end">
          <Button variant="flat" intlId="cancel" onClick={onClose} />
          <HSpacer small />
          <Button
            disabled={confirmDeleteWebhook === `` || confirmDeleteWebhook.toLowerCase() !== `webhook`}
            style={{
              backgroundColor:
                confirmDeleteWebhook === `` || confirmDeleteWebhook.toLowerCase() !== `webhook`
                  ? `rgba(0, 0, 0, 0.12)`
                  : RoutalPalette.danger,
            }}
            onClick={async () => {
              deleteWebhook(webhook);
              onClose();
            }}
            intlId="settings.developers.webhooks.delete.title"
          />
        </Grid>
      }
    >
      <Grid container direction="column">
        <Grid style={{ minWidth: `300px`, padding: `16px` }}>
          <Grid item container direction="column">
            <Text style={{ fontWeight: `bold` }} intlId="settings.developers.webhooks.delete.label" />

            <VSpacer large />

            <InputText
              id="delete_webhook_label"
              placeholder={intl.formatMessage({
                id: `settings.developers.webhooks.delete.label_ph`,
              })}
              fieldValue={confirmDeleteWebhook}
              onChange={(value: any) => setConfirmDeleteWebhook(value)}
            />
          </Grid>
        </Grid>

        <VSpacer small />

        <Grid item>
          <Text intlId="settings.developers.webhooks.delete.info" style={{ textAlign: `center` }} />
        </Grid>
      </Grid>
    </RoutalDialog>
  );
};
